export const contentPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "只做整理，不做审判",
    desc: "我们呈现事件经过与网友观点，标明来源与时间，不替任何一方下结论，也不放大未经证实的说法。",
  },
  {
    icon: "ri-emotion-normal-line",
    title: "拒绝恶意与引战",
    desc: "带有人身攻击、地域歧视、造谣传谣的内容不会出现在热评整理里。热闹可以，但底线不能丢。",
  },
  {
    icon: "ri-lightbulb-line",
    title: "观点比情绪更重要",
    desc: "我们更愿意推那些说清楚道理、提供新视角的评论，而不是单纯发泄情绪的喊话。",
  },
];

export const developments = [
  {
    year: "2019",
    title: "从一个人的收藏夹开始",
    desc: "最初只是编辑个人把每天刷到的好评论截图存下来，慢慢攒成了一个共享文档。",
  },
  {
    year: "2022",
    title: "评论区成为主角",
    desc: "我们决定把「网友热评」单独做成栏目，因为很多时候，评论区才是事件真正的价值所在。",
  },
  {
    year: "2024",
    title: "神评榜上线",
    desc: "为了让好观点被更多人看到，我们把高赞评论按专题整理成榜，一年内积累了数千条上榜内容。",
  },
  {
    year: "2026",
    title: "把围观做成一种陪伴",
    desc: "瓜田日报上线，订阅的用户可以在每天固定时间，安静地读完当天最好看的几条现场与神评。",
  },
];

export const testimonials = [
  {
    nickname: "每天读评论的老周",
    role: "瓜田日报订阅用户",
    content: "以前刷热点只会越刷越焦虑，现在每天固定看一封短邮件，看完反而心里挺平静的。",
  },
  {
    nickname: "学生党小满",
    role: "神评榜常客",
    content: "最爱神评榜，感觉是把全网最会说话的人聚在一起了。有时候一句话比文章还解压。",
  },
  {
    nickname: "上班摸鱼选手",
    role: "吃瓜群成员",
    content: "群里的氛围挺好，大家都是在认真讨论，不撕不吵，有人发链接就有人补背景，挺省心的。",
  },
  {
    nickname: "爱观察的设计师",
    role: "长期围观用户",
    content: "很喜欢你们对事件的呈现方式，不煽情、不加戏，把评论原样摆出来，这点很难得。",
  },
];

export const contactInfo = [
  { icon: "ri-mail-line", label: "联系邮箱", value: "hello@guatian-hotcomment.cc" },
  { icon: "ri-group-line", label: "吃瓜群", value: "通过下方表单订阅后获取入群方式" },
  { icon: "ri-time-line", label: "更新时间", value: "工作日每天 08:00 与 20:00" },
];